import { Dispatch } from "redux";
import AdminService from "../services/AdminService";
import { FETCH_ISIR_REC_ELEMENT_INFO } from "./types";

export const fetchIsirRecElementInfo = (aidYear: number | undefined) => {
  return async (dispatch: Dispatch<any>) => {
    dispatch({ type: FETCH_ISIR_REC_ELEMENT_INFO, payload: [] });
    const response = await AdminService.getByAidYearIsirRecordElementInfo(true, aidYear);
    dispatch({ type: FETCH_ISIR_REC_ELEMENT_INFO, payload: response });
  };
};

